import { Table, Thead, Tbody, Tr, Th, Td } from '@components/core-ui/Table/Table';
import type { EventDurationStat } from '../types/dashboardTypes';
import { formatSeconds } from '../utils';

type TProps = {
  eventDurationStats: EventDurationStat[];
};

export const EventDurationCard = ({ eventDurationStats }: TProps) => (
  <div className="bg-[var(--color-surface)] shadow-[0_8px_10px_var(--color-shadow)] rounded-[10px] p-5 min-w-0 xl:col-span-2">
    <div className="text-[var(--color-text-muted)] font-medium text-lg leading-[150%] mb-4">
      Event duration stats (24h)
    </div>
    <div className="max-h-[280px] overflow-y-auto">
      {eventDurationStats.length === 0 ? (
        <div className="p-2.5">No completed events in the last 24 hours.</div>
      ) : (
        <Table className="w-full text-xs">
          <Thead className="text-[var(--color-text-muted)] uppercase">
            <Tr className="border-b border-[var(--color-border)]">
              <Th className="py-2 pr-2 text-left min-w-[120px]">Service</Th>
              <Th className="py-2 pr-2 text-left min-w-[200px]">Stage</Th>
              <Th className="py-2 pr-2 text-right min-w-[70px]">Count</Th>
              <Th className="py-2 pr-2 text-right min-w-[70px]">Avg</Th>
              <Th className="py-2 pr-2 text-right min-w-[70px]">P50</Th>
              <Th className="py-2 pr-2 text-right min-w-[70px]">P90</Th>
              <Th className="py-2 pr-2 text-right min-w-[70px]">P95</Th>
            </Tr>
          </Thead>
          <Tbody>
            {eventDurationStats.map((eventStat: EventDurationStat) => (
              <Tr
                key={`${eventStat.service}-${eventStat.stage}`}
                className="border-b border-[var(--color-border)] last:border-0"
              >
                <Td className="py-2 pr-2 min-w-[120px]">{eventStat.service}</Td>
                <Td className="py-2 pr-2 min-w-[200px]">{eventStat.stage}</Td>
                <Td className="py-2 pr-2 text-right min-w-[70px]">{eventStat.count}</Td>
                <Td className="py-2 pr-2 text-right min-w-[70px]">{formatSeconds(eventStat.avgDurationSeconds)}</Td>
                <Td className="py-2 pr-2 text-right min-w-[70px]">{formatSeconds(eventStat.p50DurationSeconds)}</Td>
                <Td className="py-2 pr-2 text-right min-w-[70px]">{formatSeconds(eventStat.p90DurationSeconds)}</Td>
                <Td className="py-2 pr-2 text-right min-w-[70px]">{formatSeconds(eventStat.p95DurationSeconds)}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </div>
  </div>
);
